<template>
    <div>
        <button
            :class="btnClasses"
            @click="$modal.show(modalName)"
        >
            <font-awesome-icon icon="pencil" size="sm" />
        </button>
        <adaptive-form-modal
            :name="modalName"
            primary-button-text="Spara"
            title="Uppdatera uppgifter"
            method="patch"
            :redirect-to="redirectRoute"
            :action="route('api.addresses.missing-details.update', address.id)"
        >
            <h2 class="text-sm mb-xl">Kunduppgifter</h2>
            <text-input
                name="customer[name]"
                label="Namn"
                :required="true"
                :value="address.customer.name"
            />

            <text-input
                name="customer[personal_identity_number]"
                label="Personnummer"
                :required="false"
                :value="address.customer.personal_identity_number"
            />

            <text-input
                name="customer[organization_number]"
                label="Organisationsnummer"
                :required="false"
                :value="address.customer.organization_number"
            />

            <h2 class="text-sm mb-xl">Kontaktuppgifter</h2>

            <text-input
                name="contacts_details[email]"
                label="E-post"
                type="email"
                :required="true"
                :value="getContactDetailValueByType('email')"
            />

            <text-input
                name="contacts_details[mobile_phone_number]"
                label="Mobilnummer"
                :required="true"
                :value="getContactDetailValueByType('mobile_phone_number')"
            />

            <h2 class="text-sm mb-xl">Adressuppgifter</h2>

            <text-input
                name="address[house_identifier]"
                label="Fastighetsbeteckning"
                :required="true"
                :value="address.house_identifier"
            />
        </adaptive-form-modal>
    </div>
</template>

<script>
    export default {
        props: {
            initialAddress: {
                type: Object,
                required: true,
            },
            initialContactDetails: {
                type: Array,
                required: true,
            },
            redirectRoute: {
                type: String,
                required: true,
            },
            btnClasses: {
                type: String,
                required: false,
                default: 'btn-sm rounded-full is-primary',
            },
        },
        data() {
            return {
                address: this.initialAddress,
                contactDetails: this.initialContactDetails,
                modalName: `missing-address-details-${this.initialAddress.id}-modal`,
            };
        },
        methods: {
            getContactDetailValueByType(type) {
                const contactDetail = this.contactDetails.find(contactDetail => {
                    return contactDetail.type === type;
                });

                return typeof contactDetail !== 'undefined' ? contactDetail.value : '';
            },
        },
    };
</script>
